import React from 'react';
import Link from 'gatsby-link';

import { rhythm, scale } from '../utils/typography';
import Bio from '../components/Bio';
import Navigation from '../components/Navigation';

import 'codemirror/lib/codemirror.css';
import './common.css';

class Layout extends React.Component {
  render() {
    const { location, children } = this.props;

    let rootPath = `/`;
    if (typeof __PREFIX_PATHS__ !== `undefined` && __PREFIX_PATHS__) {
      rootPath = __PATH_PREFIX__ + `/`;
    }

    const header = (
      <header>
        <center>
          <div
            style={{
              ...scale(1.4),
              fontFamily: ['Montserrat', 'sans-serif'],
              fontWeight: 900,
              marginBottom: rhythm(1.5),
              marginTop: 0,
            }}
          >
            <Link
              style={{
                boxShadow: 'none',
                textDecoration: 'none',
                color: 'inherit',
              }}
              to={'/'}
            >
              Max Desiatov
            </Link>
          </div>
        </center>

        <Bio />
        <Navigation />
      </header>
    );

    return (
      <div
        style={{
          marginLeft: 'auto',
          marginRight: 'auto',
          maxWidth: rhythm(24),
          padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
        }}
      >
        {header}
        {children()}
      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.js